<template>
    <div class="Create-Plan-Map">
        <div ref="planMap" id="Create-Plan-Map" class="CPM"></div>
    </div>
</template>

<script>
import { initMap } from "@/assets/baiduMapKey/BaiduMapKey"
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import RadarOverlayCreatPlanPoint from '@/views/plan/mapPlanFlod/RadarOverlayCreatPlanPoint'
import CustomGroundOverlay from '@/views/plan/mapPlanFlod/RaderOverlayCreatPlanDay'

import { stockTypeList } from '@/assets/utils/commonData'
import { groupBy } from "@/util/arrayGroup";

export default {
    name: '',
    components: {},
    props: {
        citys: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    // 定义属性
    data() {
        return {
            ak: "fATk345GNpp3ZUuZMI0z81ZPjlM132eR",
            planMap: '',
            stockTypeList: stockTypeList
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        //1.根据原始数据计算中心坐标和缩放级别，并为地图设置中心坐标和缩放级别。
        setPointZoom(points, map) {
            console.log('points', points)
            if (points.length > 0) {
                var maxLng = points[0].lng;
                var minLng = points[0].lng;
                var maxLat = points[0].lat;
                var minLat = points[0].lat;
                var res;
                for (var i = points.length - 1; i >= 0; i--) {
                    res = points[i];
                    if (res.lng > maxLng) maxLng = res.lng;
                    if (res.lng < minLng) minLng = res.lng;
                    if (res.lat > maxLat) maxLat = res.lat;
                    if (res.lat < minLat) minLat = res.lat;
                }
                ;
                var cenLng = (parseFloat(maxLng) + parseFloat(minLng)) / 2;
                var cenLat = (parseFloat(maxLat) + parseFloat(minLat)) / 2;
                var zoom = this.getZoom(maxLng, minLng, maxLat, minLat, map);
                map.centerAndZoom(new BMapGL.Point(cenLng, cenLat), zoom);
            } else {
                //没有坐标，显示全中国
                //map.centerAndZoom(new BMapGL.Point(103.388611,35.563611), 5);
            }
        },
        //  2.计算缩放级别的函数
        getZoom(maxLng, minLng, maxLat, minLat, map) {
            var zoom = [
                "50", "100", "200", "500", "1000", "2000", "5000", "10000",
                "20000", "25000", "50000", "100000", "200000", "500000",
                "1000000", "2000000", "4000000", "8000000", "16000000"
            ]//级别18到3。
            //最大最小的坐标点
            var pointA = new BMapGL.Point(maxLng, maxLat);  // 创建点坐标A
            var pointB = new BMapGL.Point(minLng, minLat);  // 创建点坐标B
            var distance = map.getDistance(pointA, pointB).toFixed(1);  //获取两点距离,保留小数点后两位
            console.log('getZoom', pointA, pointB, distance)
            for (var i = 0, zoomLen = zoom.length; i < zoomLen; i++) {
                if (zoom[i] - distance > 0) {
                    return 18 - i + 1.8;
                    //地图范围常常是比例尺距离的10倍以上 所以加3
                }
            }
            ;
        },
        //参数数组points的每一项为每一个点的：纬度,经度
        //如 points = ['30.86660,104.390740', '30.861961,104.386963', '30.842287,104.388079', '点的纬度,点的经度'……];
        //返回中心点的数组[纬度,精度]
        getPointsCenter(points) {
            console.log('poooo', points)

            var point_num = points.length; //坐标点个数
            var X = 0, Y = 0, Z = 0;
            for (let i = 0; i < points.length; i++) {
                if (points[i] == '') {
                    continue;
                }
                let point = points[i].split(',');
                var lat, lng, x, y, z;
                lat = parseFloat(point[0]) * Math.PI / 180;
                lng = parseFloat(point[1]) * Math.PI / 180;
                x = Math.cos(lat) * Math.cos(lng);
                y = Math.cos(lat) * Math.sin(lng);
                z = Math.sin(lat);
                X += x;
                Y += y;
                Z += z;
            }
            X = X / point_num;
            Y = Y / point_num;
            Z = Z / point_num;

            var tmp_lng = Math.atan2(Y, X);
            var tmp_lat = Math.atan2(Z, Math.sqrt(X * X + Y * Y));

            return [tmp_lat * 180 / Math.PI, tmp_lng * 180 / Math.PI];
        },
        _getCityPoint(cityArr) {
            console.log("cityArr", cityArr)
            let points = []
            cityArr.forEach(item => {
                points.push([item.longitude, item.latitude])
            })
            return points;
        },
        _getCityCenterPoint(cityArr) {
            let points = []
            cityArr.forEach(item => {
                points.push(`${item.latitude},${item.longitude}`)
            })
            return points;
        },
        _getZoomPoint(cityArr) {
            let points = []
            cityArr.forEach(item => {
                points.push({ 'lng': item.longitude, 'lat': item.latitude })
            })
            return points;
        },
        //绘制线
        drawStroke() {
            let points = this._getCityPoint(this.citys)
            var plOpts = [
                { strokeColor: '#C70039', strokeWeight: "2", strokeOpacity: "1" }
            ];
            for (var index = 0; index < plOpts.length; index++) {
                let pointLine = []
                points.forEach(item => {
                    //寻找天数
                    let _day = this.citys.find(x => x.longitude == item[0] && x.latitude == item[1])
                    if (_day) {
                        const point = new BMapGL.Point(item[0], item[1]);
                        pointLine.push(point)
                    }
                })
                var polyline = new BMapGL.Polyline(pointLine, plOpts[index]);
                this.planMap.addOverlay(polyline);
            }
        },
        //绘制点和线
        drawALine() {
            let points = this._getCityPoint(this.citys)
            //画线
            this.drawStroke()
            // 画点
            let cityGroupBy = groupBy(this.citys, "cityId")
            for (const cityGroupByKey in cityGroupBy) {
                // 不同天的相同的城市
                let cityByDay = cityGroupBy[cityGroupByKey]
                let _day = points.find(p => p[0] === cityByDay[0].longitude && p[1] === cityByDay[0].latitude)
                if (!_day) {
                    continue
                }
                const point = new BMapGL.Point(cityByDay[0].longitude, cityByDay[0].latitude);
                const marker = new RadarOverlayCreatPlanPoint(point, _day.planDay, _day, cityByDay, this.citys);
                this.planMap.addOverlay(marker);
            }


            //画点
            // points.forEach(item => {
            //     //寻找天数
            //     let _day = this.citys.find(x => x.longitude == item[0] && x.latitude == item[1])
            //     if (_day) {
            //         const point = new BMapGL.Point(item[0], item[1]);
            //         // const marker = new BMapGL.Marker(point); // 创建默认标注
            //         const marker = new RadarOverlayCreatPlanPoint(point, _day.planDay, _day);
            //         // var myIcon = new BMapGL.Icon("/qiziPoint.png", new BMapGL.Size(45, 45),
            //         //   {
            //         //     anchor: new BMapGL.Size(8, 45)
            //         //   }
            //         // );
            //         // var marker = new BMapGL.Marker(point, {
            //         //     icon: myIcon,
            //         //     enableMassClear: true,
            //         //     enableDragging: true
            //         // });
            //         this.planMap.addOverlay(marker);
            //
            //         // 创建文本标注对象
            //         // var label = new BMapGL.Label(`D${_day.planDay}`,
            //         var label = new BMapGL.Label(``,
            //             {
            //                 position: point, // 指定文本标注所在的地理位置
            //                 offset: new BMapGL.Size(10, -41) // 设置文本偏移量
            //             }
            //         );
            //         // 自定义文本标注样式
            //         label.setStyle({
            //             color: 'white',
            //             fontSize: '12px',
            //             border: 'none',
            //             fontFamily: '微软雅黑',
            //             backgroundColor: '#d81e06',
            //             fontWeight: 700,
            //             transform: 'scale(0.88)'
            //         });
            //         this.planMap.addOverlay(label);
            //     }
            // })



            let centerPoints = this._getCityCenterPoint(this.citys)
            let pointC = this.getPointsCenter(centerPoints)
            const center = new BMapGL.Point(pointC[1], pointC[0]);
            console.log('were', center)
            this.planMap.setCenter(center);
            let zoomPoints = this._getZoomPoint(this.citys)
            this.setPointZoom(zoomPoints, this.planMap);
        },
        //经纬度转像素
        latitudeAndLongitudeToPixels(map) {
            let points = this._getCityPoint(this.citys)
            let positionArr = []
            points.forEach(item => {
                const point = new BMapGL.Point(item[0], item[1]);
                // 测试下 与pointToPixel转换是相同的
                const position = map.pointToOverlayPixel(point);
                positionArr.push(position)
            })
            //百度地图像素点的生成
            this.$emit('genPixels', positionArr)
        },
        //移除自定义覆盖物
        removeMarker() {
            const allOverlays = this.planMap.getOverlays()
            console.log(allOverlays, '行程图覆盖物')
            for (const item of allOverlays) {
                this.planMap.removeOverlay(item);
            }
        },
        initMap(v) {
            // if(!v) {
            //   const _bodyHeight = document.body.clientHeight
            //   const _newNavbar = document.getElementsByClassName("newNavbar")[0]
            //   const _newNavbarHeight = _newNavbar.clientHeight
            //
            //   const _navbar = document.getElementsByClassName("navbar")[0]
            //   const _navbarHeight = _navbar.clientHeight
            //
            //   const _planMapDoc = document.getElementsByClassName("CPM")[0]
            //   // _planMapDoc.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 30 -20) + 'px'
            //     _planMapDoc.style.height =  '700px'
            //
            //
            //   const _planDay = document.getElementsByClassName("Plan-Day")[0]
            //   _planDay.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 20) + 'px'
            //
            //   const _leftDay = document.getElementsByClassName("Left-Day")[0]
            //   _leftDay.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 30) + 'px'
            //
            //   const _planBudget = document.getElementsByClassName("Plan-Budget")[0]
            //   _planBudget.style.maxHeight = (_bodyHeight - _newNavbarHeight - _navbarHeight - 20) + 'px'
            // }
            // 创建地图实例  个性化地图遵照官网步骤
            let map;
            if (!this.planMap) {
                this.planMap = new BMapGL.Map("Create-Plan-Map");
            }
            map = this.planMap
            //设置地图为地球模式 （确定 自定义点覆盖物出不来 而且线的宽度不受控制）
            //map.setMapType(BMAP_EARTH_MAP);
            // 创建中心点
            const point = new BMapGL.Point(106.55839021637583, 29.626064510293723);
            // 初始化地图，设置中心点坐标和地图级别
            map.centerAndZoom(point, 3);
            //开启鼠标滚轮缩放
            map.enableScrollWheelZoom(true);
            map.setMapStyleV2({
                styleId: '870546eab641262129ced1fd21d450a3'
            });
            map.addEventListener("dragend", () => {
                this.latitudeAndLongitudeToPixels(map)
            })
            map.addEventListener("zoomend", () => {
                this.latitudeAndLongitudeToPixels(map)
            })
            //展示行程
            // const overlay = new CustomGroundOverlay(this.citys);
            // this.planMap.addOverlay(overlay); // 添加到地图
            setTimeout(() => {
                this.drawALine()
            }, 500);
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {
    }, // 生命周期 - 创建之前
    beforeMount() {
    }, // 生命周期 - 挂载之前
    beforeUpdate() {
    }, // 生命周期 - 更新之前
    updated() {
    }, // 生命周期 - 更新之后
    beforeDestroy() {
        if (this.planMap) {
            this.planMap.destroy()
            this.planMap = null
        }
    }, // 生命周期 - 销毁之前
    destroyed() {
    }, // 生命周期 - 销毁完成
    activated() {
    }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.BMap_noprint {
    z-index: 99 !important;
}

#cap,
#join,
.captext,
.jointext {
    position: absolute;
    z-index: 0;
    top: 20px;
    left: 40px;
    width: 100px;
    font-size: 16px;
}
</style>
<style scoped lang="scss">
.Create-Plan-Map {
    width: auto;

    .CPM {
        width: auto;
        height: 95vh;
    }
}

/deep/ .anchorBL {

    display: none !important;

}
</style>
